import {userConstants} from '../_constants';

export function statisticsOrderOrganisation(state = {}, action) {
  switch (action.type) {
    case userConstants.STATISTICS_ORDER_ORGANISATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.STATISTICS_ORDER_ORGANISATION_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.STATISTICS_ORDER_ORGANISATION_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}